import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import { setInterval, clearInterval } from 'worker-timers'
import { useDispatch, useSelector } from 'react-redux'
import {
  closeInvoiceFormDialog,
  getInvoicesStart,
  showInvoiceFormDialog,
  clearInvoiceEditValues
} from '../../actions'
import { getSelectedUser } from '../../selectors/adminUser.selector'
import InvoiceRowComponent from './invoiceRow.component'
import SortableTable from '../../utils/sortableTable'
import DateTimeFormat from '../../utils/DateTimeFormat'
import { convertIntToState } from '../../utils/invoice.utils'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import AddInvoice from './newInvoice.component'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import ModalComponent from '../layout/modal.component'
import mobileView from '../../utils/mobile.utils'

/**
 * @author  Pragya Gupta
 */
class NewInvoiceComponent extends React.Component {
  componentDidMount() {
    if (this.props.userType == 2) {
      this.props.getAdminUsersList()
    }
    this.props.getUserCompanyUpdateInfo()
    this.props.getInvoicesStart(this.props.selectedUser)
    this.props.getFinvoiceOperator()
    this.props.getCountryList()
  }

  render() {
    return <NewInvoice {...this.props} />
  }
}

const styles = () => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    textAlign: 'center'
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  }
})

const NewInvoice = ({
  invoiceRows,
  userType,
  invoices,
  classes,
  showInvoiceItemLoader
}) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const selectedUser = useSelector(getSelectedUser)
  const noUserSelected = userType === 2 && !selectedUser?.email

  const { showInvoiceFormDialog: isFormOpen } = useSelector(
    (state) => state.invoice
  )

  useEffect(() => {
    if (location.hash === '#scroll-to-header') {
      const element = document.getElementById('scroll-to-header')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }, [location])

  useEffect(() => {
    let invoiceSendingTimer
    // Checks if there is any status 40 ('Sending')
    let anySendingStatus = invoiceRows.some(
      (element) => element.props.status === 40
    )
    // Starts timer if there was any status 40 ('Sending')
    if (anySendingStatus) {
      invoiceSendingTimer = setInterval(() => {
        // console.log('dispatching getInvoicesStart')
        dispatch(getInvoicesStart(selectedUser))
        anySendingStatus = false
      }, 20000)
    }
    // Stops timer when dismounting
    return () => {
      if (invoiceSendingTimer) {
        return clearInterval(invoiceSendingTimer)
      }
    }
  }, [invoiceRows])
  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              {userType == 2 && <UserSelectorContainer />}
            </div>
            <div className="row" id="scroll-to-header">
              <div style={{ padding: '0 15px' }}>
                <Button
                  variant="contained"
                  style={{
                    margin: '50px 0 30px 0',
                    fontSize: '22px',
                    padding: !mobileView ? '1rem 15rem' : '4px',
                    width: '100%'
                  }}
                  onClick={() => {
                    dispatch(showInvoiceFormDialog())
                    dispatch(clearInvoiceEditValues())
                  }}
                  disabled={noUserSelected}
                >
                  {t('invoice.button10')}
                </Button>
              </div>
              <div className="dashboard-content-header">
                <h1>{t('invoice.h1')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('invoice.h3')}</h3>
                    </div>
                    <div className="panel-body pd-0">
                      <SortableTable
                        data={invoices}
                        createRowComponent={createInvoiceRow}
                        headerCells={invoiceCells}
                        enableFilters={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ModalComponent
              onClose={() => dispatch(closeInvoiceFormDialog())}
              open={isFormOpen}
              maxWidth="1200px"
              content={<AddInvoice />}
              isFullScreen={mobileView}
            ></ModalComponent>
            <Dialog
              open={showInvoiceItemLoader}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('login.dialog')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const invoiceCells = [
  {
    id: 'company_name',
    label: 'invoice.column',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'invoice_id',
    label: 'invoice.column1',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'total_sum',
    label: 'invoice.column4',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'billing_date',
    label: 'invoice.column2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile',
    filter: {
      type: 'dateFrom'
    }
  },
  {
    id: 'toDate',
    label: 'toDate',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px',
      display: 'none'
    },
    filter: {
      type: 'dateTo'
    }
  },
  {
    id: 'due_date',
    label: 'invoice.column3',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'status',
    label: 'invoice.column6',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile',
    filter: {
      type: 'select',
      labelConverter: convertIntToState,
      locationView: 'userView',
      invoiceStatus: 'extraFilter'
    }
  },
  {
    id: 'instant_payment',
    label: 'invoice.column5',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'actions',
    label: 'invoice.column7',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  }
]

const createInvoiceRow = (el, index) => {
  return (
    <InvoiceRowComponent
      index={index}
      key={el.invoice_id}
      invoiceRowData={el}
      billing_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.billing_date))}
      due_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.due_date))}
      customer={el.company_name}
      invoice_id={el.invoice_id}
      totalSumWithVAT={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.total_sum)}
      instant_payment={el.instant_payment}
      status={el.status}
      remindersent={el.remindersent}
      is_group_invoice={el.is_group_invoice}
      attached_journal_id={el.workshift_journal_id}
      functions=""
    />
  )
}

NewInvoiceComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewInvoiceComponent)
